const lunch_lengths =
 [
  '00:00',
  '00:15',
  '00:30',
  '00:45',
  '01:00'
 ];
export default lunch_lengths
